import { Button } from '@mantine/core';
import { MdArchive } from 'react-icons/md';
import { Message, MessageStatus } from '../types';

interface ArchiveButtonProps {
    message: Message;
    onArchive: (message: Message) => void;
}

export const ArchiveButton = ({ message, onArchive }: ArchiveButtonProps) => {
    const handleClick = () => {
        onArchive({ ...message, status: MessageStatus.ARCHIVED });
    };

    return (
        <Button
            leftSection={<MdArchive />}
            onClick={handleClick}
            variant="light"
        >
            Archive
        </Button>
    );
};
